interface PlanerTaskInfo {
    taskNumber: string | null;
    taskUrl: string | null;
    responsiblePerson: string | null;
    isTaskOfCurrentUserDepartment: boolean | null;
    responsibleDepartmentsNames: string[] | null;
}

export class PlanerTaskTraits {
    public readonly taskNumber: string;
    public readonly taskUrl: string;
    public readonly departmentsTitle: string;
    public readonly displayIsCurrentUserTaskTooltip: boolean;
    public readonly displayIsCurrentUserDepartmentTaskTooltip: boolean;
    public readonly displayTaskAsLink: boolean;
    public readonly displayDepartments: boolean;
    constructor(task: PlanerTaskInfo) {
        this.displayIsCurrentUserTaskTooltip = this.isUserResponsibleForTask(task);
        this.displayIsCurrentUserDepartmentTaskTooltip = !this.displayIsCurrentUserTaskTooltip && task.isTaskOfCurrentUserDepartment;
        this.displayTaskAsLink =
            this.displayIsCurrentUserTaskTooltip || this.displayIsCurrentUserDepartmentTaskTooltip || ETR.currentUserTraits.hasFullReadAccess;
        this.taskUrl = task.taskUrl;
        this.taskNumber = task.taskNumber;
        this.departmentsTitle = this.buildDepartmentsTitle(task);
        this.displayDepartments = !!this.departmentsTitle && !this.displayIsCurrentUserTaskTooltip && !this.displayIsCurrentUserDepartmentTaskTooltip;
    }
    private isUserResponsibleForTask(task: PlanerTaskInfo): boolean {
        return !!task.responsiblePerson && ETR.currentUserLogin.toLowerCase() === task.responsiblePerson.toLowerCase();
    }
    private buildDepartmentsTitle(task: PlanerTaskInfo): string {
        if (task.responsibleDepartmentsNames.length === 0) {
            return '';
        }
        return task.responsibleDepartmentsNames.reduce((prev, current) => `${prev}, ${current}`);
    }
}
